export interface ASARecord {
  assetId: string;
  assetName: string;
  unitName: string;
  totalSupply: string;
  decimals: number;
  manager: string;
  txId: string;
}

export interface CompanyOnboardResponse {
  success: boolean;
  companyId: string;
  algorandAddress?: string;
  asaAssetId?: string;
  manager?: string;
  escrowAppId?: string;
  registryAppId?: string;
  marketplaceAppId?: string;
  agentBoxKey?: string;
  totalSupply?: string;
  error?: string;
}

export async function onboardCompany(body: {
  companyId: string;
  companyName: string;
  symbol: string;
  agentId?: string;
}): Promise<CompanyOnboardResponse> {
  const res = await fetch("/api/algorand/company/onboard", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  return res.json();
}

export async function getASA(assetId: string): Promise<{ success: boolean; record: ASARecord }> {
  const res = await fetch(`/api/blockchain/asa-onboarding/${encodeURIComponent(assetId)}`);
  return res.json();
}
